import OpenApiJSON from './swagger.json'

export default OpenApiJSON.components.schemas
